export default __webpack_public_path__ + "3be28bd25a2de1b92dd5162677553c51.png";